var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckTrueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 1.6665C14.6025 1.6665 18.3333 5.39734 18.3333 9.99984C18.3333 14.6023 14.6025 18.3332 9.99999 18.3332C5.39749 18.3332 1.66666 14.6023 1.66666 9.99984C1.66666 5.39734 5.39749 1.6665 9.99999 1.6665ZM9.99999 3.33317C8.23188 3.33317 6.53619 4.03555 5.28594 5.28579C4.0357 6.53603 3.33332 8.23173 3.33332 9.99984C3.33332 11.7679 4.0357 13.4636 5.28594 14.7139C6.53619 15.9641 8.23188 16.6665 9.99999 16.6665C11.7681 16.6665 13.4638 15.9641 14.714 14.7139C15.9643 13.4636 16.6667 11.7679 16.6667 9.99984C16.6667 8.23173 15.9643 6.53603 14.714 5.28579C13.4638 4.03555 11.7681 3.33317 9.99999 3.33317ZM12.9458 6.984C13.0954 6.83296 13.2971 6.74481 13.5096 6.7376C13.7221 6.73039 13.9293 6.80467 14.0888 6.94523C14.2483 7.08578 14.3481 7.28199 14.3677 7.49369C14.3872 7.70539 14.3252 7.91657 14.1942 8.084L14.125 8.16234L9.46999 12.8182C9.31111 12.977 9.09942 13.072 8.87513 13.0851C8.65084 13.0981 8.42956 13.0283 8.25332 12.889L8.17332 12.8182L5.87499 10.5198C5.72394 10.3702 5.6358 10.1685 5.62859 9.95605C5.62138 9.74357 5.69565 9.53636 5.83621 9.37685C5.97677 9.21734 6.17298 9.11759 6.38468 9.098C6.59638 9.07842 6.80756 9.14049 6.97499 9.2715L7.05332 9.3415L8.82166 11.109L12.9467 6.984H12.9458Z",
    fill: "url(#paint0_linear_6972_3831)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6972_3831",
    x1: 18.3333,
    y1: 1.6665,
    x2: 1.66666,
    y2: 19.3748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CD3438"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckTrueIcon);
export default __webpack_public_path__ + "static/media/checkTrueIcon.2807ac18be1adc13c2ab7e70c2cc2532.svg";
export { ForwardRef as ReactComponent };